import { render } from "./TelaEditor.vue?vue&type=template&id=166493e0&ts=true"
import script from "./TelaEditor.vue?vue&type=script&lang=ts"
export * from "./TelaEditor.vue?vue&type=script&lang=ts"

import "./TelaEditor.vue?vue&type=style&index=0&id=166493e0&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__